export const environment = {
  production: true,
  // firebase: {
  //   apiKey: 'AIzaSyC7kHXTNrBhkmipWh-VVFRxFxqHgoF91hA',
  //   authDomain: 'oros-experion.firebaseapp.com',
  //   databaseURL: 'https://oros-experion.firebaseio.com',
  //   projectId: 'oros-experion',
  //   storageBucket: 'oros-experion.appspot.com',
  //   messagingSenderId: '446232779841'
  // }
  // firebase: {
  //   apiKey: 'AIzaSyDy78Q9KzRpB_6OZuaktkiuYHzPNYYaTEM',
  //   authDomain: 'oros-staging.firebaseapp.com',
  //   databaseURL: 'https://oros-staging.firebaseio.com',
  //   projectId: 'oros-staging',
  //   storageBucket: 'oros-staging.appspot.com',
  //   messagingSenderId: '1099385547553',
  //   baseUrl: 'https://oros-staging.firebaseapp.com/v1/admin/'
  // }
  firebase: {
    apiKey: 'AIzaSyBpjaJOJdlitn7Klw-8gmfiCIVtzzMiKOQ',
    authDomain: 'oros-59f9a.firebaseapp.com',
    databaseURL: 'https://oros-59f9a.firebaseio.com',
    projectId: 'oros-59f9a',
    storageBucket: 'oros-59f9a.appspot.com',
    messagingSenderId: '202339409140',
    baseUrl: 'https://oros-59f9a.firebaseapp.com/v1/admin/'
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts